const footerColumns = [
  {
    title: "索引入口",
    links: [
      { label: "热点词索引", href: "#hot-words" },
      { label: "实时热度榜", href: "#rank" },
      { label: "专题合集", href: "#collections" },
      { label: "人物黑料查询", href: "#persons" },
    ],
  },
  {
    title: "分区导航",
    links: [
      { label: "娱乐圈索引", href: "#zones" },
      { label: "直播带货索引", href: "#zones" },
      { label: "经纪合约索引", href: "#zones" },
      { label: "全部索引分区", href: "#zones" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "索引收录规则", href: "#faq" },
      { label: "热度计算说明", href: "#faq" },
      { label: "常见问题", href: "#faq" },
      { label: "更新日志", href: "#latest" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 px-4 pb-8 pt-14 text-background-100 md:px-6 md:pt-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                18
              </span>
              <span className="font-heading text-xl font-bold text-background-50">18黑料网</span>
              <span className="rounded-full border border-background-50/30 px-2 py-0.5 text-xs font-medium text-background-200">
                18+
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              18黑料网是一个关键词索引型站点，提供黑料关键词搜索与热点词索引，支持人物搜索与黑料查询，
              以专题合集与分区索引的方式，帮助你在公开信息中快速定位目标人物的相关讨论。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["关键词索引", "热点词追踪", "专题合集", "分区检索"].map((item) => (
                <span
                  key={item}
                  className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50">{column.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-background-50"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-400">
            本站内容来源于公开渠道的索引整理，仅作关键词定位与出处追溯之用，不代表对任何个人或组织的结论性判断。
          </p>
          <div className="mt-4 flex flex-col gap-3 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 18黑料网 · 黑料关键词搜索与热点词索引</p>
            <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <a href="#faq" className="whitespace-nowrap transition-colors hover:text-background-100">
                索引收录规则
              </a>
              <a href="#faq" className="whitespace-nowrap transition-colors hover:text-background-100">
                热度说明
              </a>
              <a href="#top" className="whitespace-nowrap transition-colors hover:text-background-100">
                回到顶部
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}